import { Czech } from 'flatpickr/dist/l10n/cs.js'

export function useDatePickerConfig(overrides = {}) {
  const base = {
    wrap: false,
    altFormat: 'j. F Y',
    altInput: false,
    dateFormat: 'Y-m-d',
    minDate: 'today',
    maxDate: new Date().fp_incr(30),
    weekNumbers: false,
    locale: Czech,
    inline: true,
    disableMobile: true,
    static: true,
  }

  return { ...base, ...overrides }
}
